import { Props } from '../components/parts/commons/Header'

export const useHeaderProps = (): Props => {
  const visibleLaunchAppButton = true
  return { visibleLaunchAppButton }
}
